import React, { useState, useContext } from 'react';
import { Onfido } from 'onfido-sdk-ui'
import { TabContext } from '../../home/TabProvider';
import { LoadingButton } from '@mui/lab';
import { TextField, Stack, Container, Typography } from '@mui/material';

const OnfidoImpl = () => {

    const { sharedData } = useContext(TabContext);
    const [ipAddress, setIpAddress] = useState('');
    const [email, setEmail] = useState(sharedData?.eimpData?.email || '');
    const [telephone, setTelephone] = useState(sharedData?.eimpData?.phone || '');
    const [firstName, setFirstName] = useState(sharedData?.eimpData?.firstName || '');
    const [lastName, setLastName] = useState(sharedData?.eimpData?.lastName || '');
    const [streetAddress, setStreetAddress] = useState(sharedData?.eimpData?.address?.addressLineOne || '');
    const [city, setCity] = useState(sharedData?.eimpData?.address?.city || '');
    const [state, setState] = useState(sharedData?.eimpData?.address?.provinceState || '');
    const [zipCode, setZipCode] = useState(sharedData?.eimpData?.address?.zipPostalCode || '');
    const [dob, setDob] = useState(sharedData?.eimpData?.dob || '');
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    async function bootstrapSdk(onfidoToken, workflowRunId) {

        Onfido.init({
            token: onfidoToken,
            workflowRunId: workflowRunId,
            containerId: 'onfido-mount',
            onComplete: (data) => {
                console.log('completed', data);
            },
            onError: console.error
        });
        setIsProcessing(true);
    }

    const initiateOnfidoValidation = (api) => {
        setIsLoading(true);
        const requestData = {
            ipAddress,
            email,
            telephone,
            firstName,
            lastName,
            streetAddress,
            city,
            state,
            zipCode,
            dob
        };
        fetch(api, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })
        .then(response => response.json())
        .then(data => {
            setIsLoading(false);
            bootstrapSdk(data.sdk_token, data.id);
            console.log(data);
        })
    };

    const initiateDocumentVerification = () => {
        initiateOnfidoValidation('/api/onfido/applicant/document-verification');
    };

    const initiateRegistration = () => {
        initiateOnfidoValidation('/api/onfido/applicant/registration');
    };
      
    return (
        <Container className="container">
            <Typography variant="h6" component="h6">
                Onfido ID verification
            </Typography>
            <div id="onfido-mount"></div>
            {!isProcessing && (
                <><Stack spacing={2}>
                    <TextField
                        label="IP Address"
                        placeholder="IP Address"
                        value={ipAddress}
                        onChange={(event) => setIpAddress(event.target.value)} />
                    <TextField
                        label="Email"
                        placeholder="Email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)} />
                    <TextField
                        label="Telephone"
                        placeholder="Telephone"
                        value={telephone}
                        onChange={(event) => setTelephone(event.target.value)} />
                    <TextField
                        label="First Name"
                        placeholder="First Name"
                        value={firstName}
                        onChange={(event) => setFirstName(event.target.value)} />
                    <TextField
                        label="Last Name"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={(event) => setLastName(event.target.value)} />
                    <TextField
                        label="Street Address"
                        placeholder="Street Address"
                        value={streetAddress}
                        onChange={(event) => setStreetAddress(event.target.value)} />
                    <TextField
                        label="City"
                        placeholder="City"
                        value={city}
                        onChange={(event) => setCity(event.target.value)} />
                    <TextField
                        label="State"
                        placeholder="State"
                        value={state}
                        onChange={(event) => setState(event.target.value)} />
                    <TextField
                        label="Zip Code"
                        placeholder="Zip Code"
                        value={zipCode}
                        onChange={(event) => setZipCode(event.target.value)} />
                    <TextField
                        label="Date of Birth"
                        placeholder="Date of Birth"
                        value={dob}
                        onChange={(event) => setDob(event.target.value)} />
                    <Stack direction="row" spacing={2}>
                        <LoadingButton
                            size="small"
                            loading={isLoading}
                            onClick={initiateRegistration}
                            loadingPosition="center"
                            variant="contained">
                                Initiate Registration
                        </LoadingButton>
                        <LoadingButton
                            size="small"
                            loading={isLoading}
                            onClick={initiateDocumentVerification}
                            loadingPosition="center"
                            variant="contained">
                                Initiate Document Verification
                        </LoadingButton>
                    </Stack>
                </Stack></>
            )}
        </Container>
    );
};

export default OnfidoImpl;